import { getConfig } from '@b2ag/micro-front-tools'
import { isEmpty } from '@b2ag/utils/src/isEmpty'
import { toInteger } from 'es-toolkit/compat'
import { getPartnerLogoUrl } from '@b2ag/micro-front-partner-sdk'
export function mapFromApi(cooperative = {} as any) {
  const {
    id,
    name,
    currency,
    locales,
    customer_support_opening_hours: openingHours = '',
    customer_support_phone_no: phone = '',
    customer_support_email: email = '',
  } = cooperative

  const image = getPartnerLogoUrl(getConfig('CLOUDINARY_BUCKET_NAME'), cooperative.id)

  if (isEmpty(id + '')) return {}

  return {
    id: id + '',
    name,
    image,
    currency,
    locales,
    customerSupport: { openingHours, phone, email },
  }
}

export function mapToApi(cooperative = {} as any) {
  const { id, name, membershipNumber } = cooperative

  if (isEmpty(id + '')) return {}

  return {
    id: toInteger(id),
    name,
    membership_number: membershipNumber,
  }
}
